import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Tabs from '@commons/tabs'
import ActiveAppointments from './actives'
import BookingAppointments from './bookings'
import HistoryAppointments from './histories'
const DoctorRequestAppointmentsPage = () => {
  const tabs = [
    {
      title: 'Active',
      key: 'active',
      Component: ActiveAppointments,
    },
    {
      title: 'Bookings',
      key: 'bookings',
      Component: BookingAppointments,
    },
    {
      title: 'History',
      key: 'history',
      Component: HistoryAppointments,
    },
  ]
  return (
    <Column rowGap={20}>
      <CardHeading title="Appointments" />
      <Tabs items={tabs} restore={true} />
    </Column>
  )
}

export default DoctorRequestAppointmentsPage
